export default __webpack_public_path__ + "static/media/Fashion-min.c71d91b3.png";